var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-.084,24.084l19.021-7.907L7.823,5.063-.084,24.084Zm6.637-10.755l4.118,4.118-7.048,2.93,2.93-7.048Zm8.856,2.148l-2.741,1.139-5.285-5.285,1.139-2.741,6.886,6.887Zm-1.759-7.928c.962-.963,1.43-1.942,1.39-2.911-.062-1.507-1.316-2.607-1.329-2.618l1.292-1.527c.079.067,1.935,1.664,2.035,4.062.064,1.551-.6,3.034-1.974,4.408l-1.414-1.414Zm9.998,3.936l-1.521,1.298c-.006-.008-.668-.754-1.538-.782-.565-.043-1.121.263-1.695.837l-1.414-1.414c.99-.989,2.08-1.46,3.205-1.421,1.723.071,2.842,1.338,2.964,1.482Zm-2.648-9.985c0-.828.672-1.5,1.5-1.5s1.5.672,1.5,1.5-.672,1.5-1.5,1.5-1.5-.672-1.5-1.5Zm-2,5c0-.828.672-1.5,1.5-1.5s1.5.672,1.5,1.5-.672,1.5-1.5,1.5-1.5-.672-1.5-1.5ZM8,2.5c0-.828.672-1.5,1.5-1.5s1.5.672,1.5,1.5-.672,1.5-1.5,1.5-1.5-.672-1.5-1.5Zm15,16c0,.828-.672,1.5-1.5,1.5s-1.5-.672-1.5-1.5.672-1.5,1.5-1.5,1.5.672,1.5,1.5ZM1,3.5c0-.828.672-1.5,1.5-1.5s1.5.672,1.5,1.5-.672,1.5-1.5,1.5-1.5-.672-1.5-1.5Zm17,19c0,.828-.672,1.5-1.5,1.5s-1.5-.672-1.5-1.5.672-1.5,1.5-1.5,1.5.672,1.5,1.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParty);
export default __webpack_public_path__ + "static/media/party.6b7bd45e56d7405eae8c81a702467eab.svg";
export { ForwardRef as ReactComponent };